import React, { Component } from 'react';

import './DIS.css';

import { services2 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import RecentArticles from '@acri-tools/react-tools/components/_articles/RecentArticles/RecentArticles';
import { Helmet } from 'react-helmet';
import { get_page_title } from '../../utils/config';
import DISImg from './DIS.png'

interface Props {
}
interface State {
}

class DIS extends Component<Props, State>{
    render() {
        return (
            <Page
                id="dis"
                banner={{
                    title: "DIS",
                    bannerImage: services2,
                    topBar: true
                }}
                footer
            >
                <Helmet>
                    <title>{ get_page_title('DAMPS - Data Information Service') }</title>
                    <meta 
                        name="description" 
                        content="Learn more about DAMPS Data Information Service (DIS)"
                    />
                </Helmet>
                <div className="page-content">
                    <div className="centered-content padding">
                        <h1 className="title-3">
                            DIS Introduction
                        </h1>

                        <p>
                            The <a href="https://online.tableau.com/" target="_blank">Data Information Service (DIS)</a> is a 
                            Data-warehouse repository with a Business Intelligence front-end which
                            collects information of Earth Observation data holdings held in various services (including archiving and
                            processing but also dissemination and potentially others) and provides a data-centric view of the data managed by EOP-GT.
                        </p>
                        <p>
                            DIS offers visibility and understanding of the data, as well as easy comparison of the contents 
                            of different repositories where the data is duplicated.
                        </p>
                        <br/>
                        <br/>
                        <h2 className="title-3">
                            DIS provides
                        </h2>
                        <ul className='dis-list'>
                            <li>
                                A single repository and user view of the comprehensive information regarding the data under the 
                                management of the organisation;
                            </li>
                            <li>
                                Not only information regarding the data itself but also information on the value added to the data 
                                by the various services (eg what higher level dataset was produced based on what lower level and 
                                auxiliary input datasets by means of what processor), which represents a major contribution to the 
                                tracing of the provenance of the data. 
                            </li>
                        </ul>
                        <br/>
                        <br/>

                        <p className="description">
                            The stakeholders are mostly Management, which DIS assists decision making, 
                            and Operations, who are supported by a detailed and accurate view of the location, 
                            status and cross-relationship of the data in the various source systems.  
                        </p>
                        <br/>
                        <div className="centered">
                            <img
                                alt="DIS logo"
                                className="dis-image"
                                src={DISImg}
                            />
                        </div>

                        <br/>
                        <br/>
                        <h2 className="title-3">
                            Recent Articles
                        </h2>
                        <RecentArticles
                            categories={[ 'DIS' ]}
                            load_more_categories_only
                        />
                    </div>
                </div>
            </Page>
        );
    }

};


export default DIS;
